<template>
  <div class="row items-center">
    <div class="col-12 flex">
      <slot />
    </div>
    <div class="col"></div>
  </div>
</template>

<script>
export default {

}
</script>